import * as Types from 'src/actions/project/comments/create-child-comment/Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import { RootState } from 'src/reducers/RootReducer';
import ProjectChildComment from 'src/entities/ProjectChildComment';
import ValidatorService from 'src/services/validation/Validation.service';

export interface CreateProjectChildCommentAttempt extends Action {
  type: Types.CREATE_PROJECT_CHILD_COMMENT_ATTEMPT;
}

export interface CreateProjectChildCommentSuccess extends Action {
  type: Types.CREATE_PROJECT_CHILD_COMMENT_SUCCESS;
}

export interface CreateProjectChildCommentFailure extends Action {
  type: Types.CREATE_PROJECT_CHILD_COMMENT_FAILURE;
  payload: {};
}

export type CreateProjectChildCommentAction =
  CreateProjectChildCommentAttempt
  | CreateProjectChildCommentSuccess
  | CreateProjectChildCommentFailure;

export interface CreateProjectChildCommentThunk extends ThunkAction<Promise<CreateProjectChildCommentAction>,
  RootState, string> {
}

export const createProjectChildCommentAttempt: ActionCreator<CreateProjectChildCommentAttempt> = () => (
  {
    type: Types.CREATE_PROJECT_CHILD_COMMENT_ATTEMPT
  }
);

export const createProjectChildCommentSuccess: ActionCreator<CreateProjectChildCommentSuccess> = () => (
  {
    type: Types.CREATE_PROJECT_CHILD_COMMENT_SUCCESS
  }
);

export const createProjectChildCommentFailure: ActionCreator<CreateProjectChildCommentFailure> = (error: {}) => (
  {
    type: Types.CREATE_PROJECT_CHILD_COMMENT_FAILURE,
    payload: error
  }
);

export const createProjectChildComment: ActionCreator<CreateProjectChildCommentThunk> =
  (projectChildComment: ProjectChildComment): CreateProjectChildCommentThunk => {
    return (dispatch: Dispatch<RootState>): Promise<CreateProjectChildCommentAction> => {
      dispatch(createProjectChildCommentAttempt());

      return ApiClient.childComment.create(projectChildComment, { commentId: projectChildComment.parentCommentId })
        .then((): CreateProjectChildCommentSuccess => {
          return dispatch(createProjectChildCommentSuccess());
        }).catch((e: { response: { data: { error: {} } } }): CreateProjectChildCommentFailure => {
          const errorMessages = ValidatorService
            .translateValidations(e && e.response && e.response.data && e.response.data.error);

          return dispatch(createProjectChildCommentFailure(errorMessages));
        });
    };
  };



// WEBPACK FOOTER //
// ./src/actions/project/comments/create-child-comment/CreateProjectChildComment.actions.tsx